import React from "react";

const DegreeHeadContent = () => {
  return (
    <div className="birthCertHeadContentContainer">
      <h2>
        Degree Certificate <span>Apostille</span> in Bangalore
      </h2>
      <p>
        Degree apostille is a vital process for individuals who wish to pursue
        higher education, employment, or other opportunities abroad. It involves
        authenticating a degree certificate, ensuring it is recognized and
        accepted in foreign countries that are part of the Hague Apostille
        Convention. Goodway Attestation Services in Bangalore provides
        specialized assistance in obtaining degree apostille, making the process
        smooth and efficient.
      </p>
    </div>
  );
};

export default DegreeHeadContent;
